const mutations = {
  links(state, { links, type }) {
    state.links = { ...state.links, ...{ [type]: links } }
  },
}

export default mutations
